import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import {
	ActionButtonGroup,
	ActionButtonGroupAction
} from '@/components/ActionButtonGroup/ActionButtonGroup';
import { Hcphco } from '@/core/graphql/generated/types';

import { useDcrControlAction } from '../DcrControl/useDcrControlAction';
import { useShareAction } from '../ShareAction/useShareAction';

import { profilePageHeaderStyles as sx } from './ProfilePageHeader.styles';

type Props = {
	profile: Hcphco | null;
};

export const ProfilePageHeader = ({ profile }: Props) => {
	const { t } = useTranslation();
	const dcrAction = useDcrControlAction();
	const share = useShareAction();

	const actions: ActionButtonGroupAction[] = [
		...(dcrAction ? [dcrAction] : []),
		{
			...share.action,
			variant: dcrAction ? 'outlined' : 'contained',
			hidden: !profile
		}
	];

	return (
		<Box sx={sx.headerRow}>
			<Typography sx={sx.typeLabel} variant='body1'>
				{profile?.__typename === 'HCP' ? t('HCP') : t('HCO')}
			</Typography>

			<Box sx={sx.headerActions}>
				<ActionButtonGroup actions={actions} />

				{share.modal}
			</Box>
		</Box>
	);
};
